import { render } from "./AgencyCareDeskPanel.vue?vue&type=template&id=ca28bcb0&scoped=true"
import script from "./AgencyCareDeskPanel.vue?vue&type=script&lang=js"
export * from "./AgencyCareDeskPanel.vue?vue&type=script&lang=js"

import "./AgencyCareDeskPanel.vue?vue&type=style&index=0&id=ca28bcb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca28bcb0"]])

export default __exports__